import styled from "styled-components";

export const ContainerGHE = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const ViewFilter = styled.div<{ margin: number, isMaxColumn?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: ${(props) => (props.margin > 0 ? props.margin + "px" : "")};
  margin-bottom: ${(props) => (props.margin > 0 ? props.margin + "px" : "")};
  margin-right: ${(props) => (props.margin > 0 ? props.margin + "px" : "")};
  margin-top: ${(props) => (props.margin > 0 ? props.margin - 20 + "px" : "")};

  @media screen and (max-width: 705px) {
    flex-direction: ${props => props.isMaxColumn ? "column" : "row"};
  }

`;

export const InputSearch = styled.input`
  width: 317px;
  height: 44px;
  border: 1px solid #e7e7e8;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #667085;
  padding-left: 35px;

  &:focus {
    outline: none;
  }

 @media screen and (max-width: 376px) {
  width: 290px;
 }
`;

export const ComeBack = styled.a`
  text-decoration: none;
  color: #0a5190;
  cursor: pointer;
`;
